import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import UserDateTimezone from '../../../components/user-date-timezone-format/index';
import { messages } from '../messages';

const CreatedDateTime = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  if (!fulfillment?.createDateTime) {
    return '';
  }

  return <UserDateTimezone dateTime={fulfillment.createDateTime} />;
};

CreatedDateTime.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const createdDate = {
  getMessageDescriptor: () => messages.createdDate,
  name: <FormattedMessage {...messages.createdDate} />,
  id: 'createdDate',
  render: (data) => <CreatedDateTime fulfillmentId={data.id} />,
};
